export const sortPayments = (payments, comments) => {
    const sortedPayments = payments.reduce((acc, payment) => {
        const { payment_type, due_date, ...rest } = payment
        const {
            local_id,
            sub_id,
            quantity,
            numberOfPayments,
            ...filteredPayment
        } = rest

        if (!acc[payment_type]) {
            acc[payment_type] = {
                comment: comments[payment_type] || '',
                total: 0,
                payments: [],
            }
        }

        const formattedPayment = { ...filteredPayment, payment_type }

        if (due_date) {
            formattedPayment.due_date = formatDate(due_date)
        }

        acc[payment_type].payments.push(formattedPayment)
        acc[payment_type].total = (
            parseFloat(acc[payment_type].total) +
            parseFloat(payment.amount || 0)
        ).toFixed(2)

        return acc
    }, {})

    return sortedPayments
}

export const processClient = (client) => {
    return {
        last_name: client.clientsName,
        id_number: client.optionalId || null,
    }
}

export const formatDate = (date) => {
    const [year, month, day] = date.split('-')
    return `${day}/${month}/${year}`
}
